// get_translation_languages
export const GET_TRANSLATION_LANGUAGE = 'get_translation_languages';
export const GET_TRANSLATION_LANGUAGE_SUCCESSFUL =
  'get_translation_languages_successfull';
export const GET_TRANSLATION_LANGUAGE_FAILED =
  'get_translation_languages_failed';

// add_translation_language
export const ADD_TRANSLATION_LANGUAGE = 'add_translation_language';
export const ADD_TRANSLATION_LANGUAGE_SUCCESSFUL =
  'add_translation_language_successfull';
export const ADD_TRANSLATION_LANGUAGE_FAILED =
  'add_translation_language_failed';

// translate_translation_keys
export const TRANSLATE_TRANSLATION_KEYS = 'translate_translation_keys';
export const TRANSLATE_TRANSLATION_KEYS_SUCCESSFUL =
  'translate_translation_keys_successfull';
export const TRANSLATE_TRANSLATION_KEYS_FAILED =
  'translate_translation_keys_failed';

// delete_translation_language
export const DELETE_TRANSLATION_LANGUAGE = 'delete_translation_language';
export const DELETE_TRANSLATION_LANGUAGE_SUCCESSFUL =
  'delete_translation_language_successfull';
export const DELETE_TRANSLATION_LANGUAGE_FAILED =
  'delete_translation_language_failed';
